import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=13ae5405&scoped=true&"
import script from "./productInformation.vue?vue&type=script&lang=js&"
export * from "./productInformation.vue?vue&type=script&lang=js&"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=13ae5405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae5405",
  null
  
)

export default component.exports